import React from 'react';

import classNames from 'classnames';
import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

const ImportButton = ({ isDisabled, isMobile, onClick, ...rest }) => {
  const classes = classNames('hot-button hot-button--primary', {
    'hot-button--block': isMobile
  });

  return (
    <button
      className={classes}
      disabled={isDisabled}
      onClick={onClick}
      {...rest}
    >
      <Icon prefix="fa" iconName="upload" className="_mr-2" />
      <I18n label="general.import" />
    </button>
  );
};

ImportButton.propTypes = {
  'isDisabled': PropTypes.boolean,
  'isMobile': PropTypes.boolean,
  'data-test': PropTypes.string,
  'onClick': PropTypes.fn
};

export default inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))(ImportButton);
